import { BehaviorSubject } from 'rxjs';
import { MetadataEntityFieldData } from '../decorators';
import * as Enumerable from 'linq';

export class MetadataFieldMapper {

    private readonly _availableFields = new BehaviorSubject<MetadataEntityFieldData[]>([]);
    public readonly availableFields$ = this._availableFields.asObservable();

    private readonly _requiredFields = new BehaviorSubject<MetadataEntityFieldData[]>([]);
    public readonly requiredFields$ = this._requiredFields.asObservable();

    public readonly mappings = new Map<string, MetadataEntityFieldData>();
    public readonly reverseMapping = new Map<string, string>();

    constructor(
        public readonly allFields: MetadataEntityFieldData[]
    ) {
        this._availableFields.next(allFields);
        this.updateRequiredFields();
    }

    public addMapping(source: string, destination: MetadataEntityFieldData) {

        if (destination) {
            // We are setting a mapping
            this.mappings.set(source, destination);
            this.reverseMapping.set(destination.path, source);
        } else {
            // We are probably removing a mapping
            const savedDestination = this.mappings.get(source);
            if (savedDestination) {
                this.mappings.delete(source);
                this.reverseMapping.delete(savedDestination?.path);
            }
        }

        const available = Enumerable.from(this.allFields)
            .where(x => !this.reverseMapping.has(x.path))
            .toArray();

        this._availableFields.next(available);
        this.updateRequiredFields();
    }


    private updateRequiredFields() {
        this._requiredFields.next(Enumerable.from(this._availableFields.value).where(x => x.required && x.importable).toArray());
    }
}